import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Link } from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";
import { Header2 } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import {
  getFontFamily,
  getSize,
  hexToRgba,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { CareerOpening } from "../CareerOpening";

import { Careers as CareersHero } from "../careers";

const Content = styled.div`
  background-color: ${({
    theme: {
      colors: { offWhite },
    },
  }) => hexToRgba(offWhite, 0.9)};
  @media screen and (min-width: ${getSize("default")}) {
    padding: 0px 0px 60px 0px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    padding: 68px 0px 76px 0px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    padding: 78px 0px 84px 0px;
  }
  text-align: center;
`;

const JobTitle = styled.h3`
  text-transform: uppercase;
  color: ${p => p.theme.colors.lightGrey};
  font-size: 15px;
  letter-spacing: 0.9px;
  line-height: 50px;
  margin: 30px 0px 0px 0px;
`;

const ExpandCaret = styled.span`
  border-top: 2px solid
    ${({
      theme: {
        colors: { grey },
      },
    }) => grey};
  border-right: 2px solid
    ${({
      theme: {
        colors: { grey },
      },
    }) => grey};
  display: inline-block;
  height: 0.625em;
  margin-left: 24px;
  margin-right: -24px;
  transform: rotate(${({ expanded }) => (expanded ? "135" : "45")}deg);
  transform-origin: 50% 31%;
  width: 0.625em;
`;

const CareerOpeningsList = styled.ul`
  list-style: none;
  margin: 0 auto;

  padding: 0px 38px;
  @media screen and (min-width: ${getSize("mobile480")}) {
    padding: 0px 46px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    padding: 0px 50px;
    max-width: 700px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    padding: 0px 0px;
  }
`;

const CareerOpeningsListItem = styled.li`
  list-style: none;
  margin: 28px auto;
  padding: 0px 0px 24px 0px;
`;

const CareerLink = styled(Link)`
  color: ${({
    theme: {
      colors: { blueGrey },
    },
  }) => blueGrey};
  ${getFontFamily("medium")}
  font-size: 15px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  ${({ id }) =>
    id
      ? `::before {
    content: "";
    display: block;
    position: relative;
    width: 0;
    height: 7em;
    margin-top: -7em;
  }`
      : ""}
  > span {
    white-space: nowrap;
  }
`;

export function CareersList({ career: activeCareer, careers }) {
  return (
    <div>
      <CareersHero />
      <Content>
        <Header2 id="top">Current Openings</Header2>
        <JobTitle>Job Title</JobTitle>
        <CareerOpeningsList>
          {careers.map(({ frontmatter: { title, uri }, id }) => {
            let careerPosting = activeCareer && activeCareer.id === id;
            const titleParts = title.split(" ");
            const lastPartIndex = titleParts.length - 1;
            return (
              <CareerOpeningsListItem key={id}>
                <CareerLink
                  id={careerPosting ? "post" : undefined}
                  to={careerPosting ? "/careers#top" : `/careers/${uri}#post`}
                >
                  {titleParts.slice(0, lastPartIndex).join(" ")}
                  <span>
                    {` ${titleParts[lastPartIndex]}`}
                    <ExpandCaret expanded={!!careerPosting} />
                  </span>
                </CareerLink>
                {careerPosting && <CareerOpening career={activeCareer} />}
              </CareerOpeningsListItem>
            );
          })}
        </CareerOpeningsList>
      </Content>
    </div>
  );
}

CareersList.propTypes = {
  career: PropTypes.object,
  careers: PropTypes.array,
};
